import { hasValue } from 'globalutils/fmUtils';
import PropTypes from 'prop-types';
import React, { lazy, useRef, useState } from 'react';
import Styled from '../style';
import { RegistrationDetails } from './RegistrationDetails';
import RenderComponent from './RenderComponent';
import { initialValues, schema } from './config';

const layout = window?.$environment?.CURRENT_LAYOUT;
export const SubHeader = lazy(() => import(`globalcomponents/SubHeader/${layout}`));
export const ErrorIcon = lazy(() => import(`globalcomponents/ErrorIcon/${layout}`));
export const Button = lazy(() => import(`globalcomponents/UI/Button/${layout}`));
export const Form = lazy(() => import(`globalcomponents/UI/Form/${layout}`));
export const CheckBox = lazy(() => import(`globalcomponents/UI/Toggle/${layout}`));
export const Label = lazy(() => import(`globalcomponents/UI/Label/${layout}`));
export const Message = lazy(() => import(`globalcomponents/UI/Message/${layout}`));
const Modal = require(`globalcomponents/UI/Modal/${layout}`);
export const FormStyle = require(`globalcomponents/UI/Form/${layout}/serverStyle`);
export const Timezone = lazy(() => import(`@/modules/Timezone/${layout}`));

const RegisrationForm = ({ apiStatus, i18n, theme, states, registration, saveRegistration, callback }) => {
  const apiId = 'saveRegistration';
  const hasApiStatus = hasValue(apiStatus.status, 'api', apiId);
  const [open, setOpen] = useState(false);

  const paymentRef = useRef();
  const [selectedItem, setSelectedItem] = useState({
    cost: '',
    totalAmount: 0,
    salesTax: '',
  });
  const [ModalObject, setModalObject] = useState({
    header: '',
    content: () => {},
  });
  const clickedModal = (e) => {
    setOpen(true);
  };
  const closeModal = (event) => {
    setOpen(false);
  };
  const [registrationPopup, setregistrationPopup] = useState(326);
  const [registrationcolorPopup, setregistrationcolorPopup] = useState(false);
  const [captcha, setCaptcha] = useState();

  const getCaptcha = (captcha) => {
    setCaptcha(captcha);
  };

  const showPaymentInfo = (fields) => {
    if (captcha) {
      setregistrationPopup(326);
      setModalObject({
        header: '',
        content: () => {
          return (
            <RegistrationDetails
              i18n={i18n}
              closeModal={closeModal}
              setModalObject={setModalObject}
              data={{ ...fields, selectedItem }}
              saveRegistration={saveRegistration}
              callback={callback}
              setOpen={setOpen}
              open={open}
              isFlexRegistration={registration.isFlexRegistration}
              setregistrationPopup={setregistrationPopup}
              setregistrationcolorPopup={setregistrationcolorPopup}
              captcha={captcha}
            />
          );
        },
      });
      clickedModal();
    }
  };

  return (
    <Styled.Wrapper>
      <Form
        type="server"
        direction="column"
        initialValues={{ ...initialValues, state: states[0] || '' }}
        RenderComponent={RenderComponent}
        handleOnSubmit={() => {}}
        customProps={{
          hasApiStatus,
          i18n,
          theme,
          states,
          registration,
          selectedItem,
          setSelectedItem,
          paymentRef,
          showPaymentInfo,
          getCaptcha,
          captcha,
        }}
        validationSchema={schema}
      />
      <Modal.default
        open={open}
        setOpen={setOpen}
        data={ModalObject}
        disableEscapeKeyDown={true}
        disableBackdropClick={true}
        registrationPopup={registrationPopup}
        registrationcolorPopup={registrationcolorPopup}
        isSuccess
      />
    </Styled.Wrapper>
  );
};

export default RegisrationForm;

RegisrationForm.propTypes = {
  apiStatus: PropTypes.object.isRequired,
};
